(() => {
  if (window.CTEDiveSiteDialogs) return;
  const instances = new Map();
  let active = null;
  let locked = null;

  function lockPage() {
    const body = document.body;
    const props = ['position', 'top', 'left', 'width', 'overflow', 'paddingRight'];
    const styles = Object.fromEntries(props.map(prop => [prop, body.style[prop]]));
    const x = window.scrollX;
    const y = window.scrollY;
    const gap = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    locked = { x, y, styles };
    body.style.position = 'fixed';
    body.style.top = `-${y}px`;
    body.style.left = `-${x}px`;
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    if (gap) body.style.paddingRight = `${parseFloat(getComputedStyle(body).paddingRight || '0') + gap}px`;
  }

  function unlockPage() {
    if (!locked) return;
    const saved = locked;
    locked = null;
    Object.assign(document.body.style, saved.styles);
    const html = document.documentElement;
    const oldBehavior = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo({ left: saved.x, top: saved.y, behavior: 'instant' });
    html.style.scrollBehavior = oldBehavior;
  }

  function finish(entry) {
    if (active !== entry) return;
    active = null;
    unlockPage();
    if (entry.opener && entry.opener.isConnected) entry.opener.focus({ preventScroll: true });
  }

  function open(entry, opener) {
    if (active === entry) return;
    if (active) {
      const previous = active;
      previous.dialog.close();
      finish(previous);
    }
    entry.opener = opener;
    // Do not lock the document if the browser refuses showModal().
    try { entry.dialog.showModal(); } catch (_) { return; }
    active = entry;
    lockPage();
    entry.title.focus({ preventScroll: true });
    entry.dialog.querySelector('.ct-site-modal__body').scrollTop = 0;
  }

  function mount(root) {
    if (instances.has(root)) return;
    const probe = document.createElement('dialog');
    if (typeof probe.showModal !== 'function') return; // Native <details> remain usable.
    const entries = new Map();

    root.querySelectorAll('[data-ct-site-dialog-card]').forEach(card => {
      const details = card.querySelector('[data-ct-site-details]');
      const summary = details && details.querySelector('summary');
      const content = details && details.querySelector('[data-ct-site-detail-content]');
      const titleLink = card.querySelector('[data-ct-site-open]');
      if (!details || !summary || !content || !titleLink) return;
      const name = card.dataset.siteName || titleLink.textContent;
      const dialog = document.createElement('dialog');
      dialog.className = 'ct-site-modal';
      dialog.id = `${card.id}-dialog`;
      const headingId = `${dialog.id}-title`;
      dialog.setAttribute('aria-labelledby', headingId);
      dialog.setAttribute('aria-modal', 'true');
      const header = document.createElement('div');
      header.className = 'ct-site-modal__header';
      const heading = document.createElement('h2');
      heading.id = headingId;
      heading.tabIndex = -1;
      heading.textContent = name;
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'ct-site-modal__close';
      close.textContent = 'Close ×';
      close.setAttribute('aria-label', `Close ${name} details`);
      header.append(heading, close);
      const body = document.createElement('div');
      body.className = 'ct-site-modal__body';
      body.append(content);
      dialog.append(header, body);
      root.append(dialog);
      details.open = false;
      const attributes = ['aria-haspopup', 'aria-controls'];
      for (const control of [titleLink, summary]) {
        control.setAttribute('aria-haspopup', 'dialog');
        control.setAttribute('aria-controls', dialog.id);
      }
      card.classList.add('ct-site-card--interactive');
      const entry = { card, dialog, title: heading, titleLink, summary, details, content, opener: null };
      entries.set(card, entry);
      const closeDialog = () => dialog.close();
      const onClose = () => finish(entry);
      const onCancel = event => { event.preventDefault(); dialog.close(); };
      let backdropDown = false;
      const outside = event => {
        const box = dialog.getBoundingClientRect();
        return event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom);
      };
      const onPointerDown = event => { backdropDown = outside(event); };
      const onBackdrop = event => { if (backdropDown && outside(event)) dialog.close(); backdropDown = false; };
      close.addEventListener('click', closeDialog);
      dialog.addEventListener('close', onClose);
      dialog.addEventListener('cancel', onCancel);
      dialog.addEventListener('pointerdown', onPointerDown);
      dialog.addEventListener('click', onBackdrop);
      entry.cleanup = () => {
        if (active === entry) { dialog.close(); finish(entry); }
        close.removeEventListener('click', closeDialog);
        dialog.removeEventListener('close', onClose);
        dialog.removeEventListener('cancel', onCancel);
        dialog.removeEventListener('pointerdown', onPointerDown);
        dialog.removeEventListener('click', onBackdrop);
        details.append(content);
        for (const control of [titleLink, summary]) for (const attr of attributes) control.removeAttribute(attr);
        card.classList.remove('ct-site-card--interactive');
        dialog.remove();
      };
    });

    const onClick = event => {
      if (event.defaultPrevented || event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const target = event.target.closest ? event.target : event.target.parentElement;
      const card = target && target.closest('[data-ct-site-dialog-card]');
      const entry = entries.get(card);
      if (!entry) return;
      const trigger = target.closest('[data-ct-site-open], [data-ct-site-details] > summary');
      if (!trigger && target.closest('a, button, summary, input, select, textarea, label, [contenteditable="true"]')) return;
      if (!trigger && window.getSelection && String(window.getSelection()).trim()) return;
      event.preventDefault();
      open(entry, trigger || entry.titleLink);
    };
    root.addEventListener('click', onClick);
    instances.set(root, () => {
      root.removeEventListener('click', onClick);
      for (const entry of entries.values()) entry.cleanup();
      instances.delete(root);
    });
  }

  function init(scope = document) {
    if (scope.matches && scope.matches('[data-ct-anilao-guide-v2], [data-ct-destination-guide]')) mount(scope);
    scope.querySelectorAll('[data-ct-anilao-guide-v2], [data-ct-destination-guide]').forEach(mount);
  }
  window.CTEDiveSiteDialogs = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of instances) if (event.target.contains(root)) cleanup();
  });
})();
